enum ClicksEnum {
  AcceptConsentSSO = "accept_consent_sso",
  GeolocationAuthorization = "geoloc_",
  UniversesValidation = "valid_universe",
  UniversesSkip = "skip_universe",
  RecommendedListSkip = "Skip_recommendation",
  PreferencesValidation = "valid_pref",
  PreferencesSkip = "skip_tag",
  ProofValueValidation = "valid_proof_value",
  ProofValueSkip = "skip_proof_value",
  Bell = "bell",
  ClearAllFilters = "clear_all_filters",
  ClearFilter = "clear_filter",
  DeniedConsentSSO = "denied_consent_sso",
  FilterSelection = "filter_selection",
  ForgotPassword = "reset_password",
  Help = "help",
  Email = "email",
  Login = "login",
  OfferFunnelStepNumber = "offer_funnel_",
  OpenFilters = "open_filters",
  NeedHelpSubmit = "need_help_submit",
  Requests = "requests",
  RequestDetail = "requests_details",
  RequestUpdate = "request_update",
  RequestRecommendations = "click_recommendations",
  RequestRecommendationDetail = "click_recommendation",
  RequestChooseRecommendation = "choose_recommendation",
  RequestMapsRecommendation = "maps_recommendation",
  RequestRejectProposal = "reject_proposal",
  RequestPreviousProposals = "previous_proposals",
  Subscribe = "subscribe",
  Search = "search_query",
}

export default ClicksEnum;
